<template>
  <transition name="el-zoom-in-center">
    <el-dialog title="稽查码取证图片" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-carousel height="500px" :autoplay="false">
        <el-carousel-item v-for="(item, i) in dataarr" :key="i">
          <el-row>
            <el-col :span="12">
              <el-button plain size="mini" @click="item.show = true">查看取证图片
              </el-button>
              <el-image :src="src + item.id" v-if="item.show" style="height: 600px" @click="getimg(item)">
                <div slot="placeholder" class="image-slot">
                  加载中
                  <span class="dot">...</span>
                </div>
              </el-image>
            </el-col>
            <el-col :span="12">
              备注：
              {{ item.remark }}
            </el-col>
          </el-row>


        </el-carousel-item>
      </el-carousel>
      <el-image src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" id="imgclick" 
        style="height: 1px" :preview-src-list="[srcimg]">
        <div slot="placeholder" class="image-slot">
          加载中
          <span class="dot">...</span>
        </div>
      </el-image>
    </el-dialog>
  </transition>
</template>

<script>
import PanThumb from "@/components/PanThumb";
import { productlist } from "@/api/base";
import { selectcorrect } from "@/api/physical";
export default {
  components: { PanThumb },
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null
        };
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      dataarr: [],
      src:
        process.env.VUE_APP_BASE_API +
        "/api/out/msc/selectimage?id=",
      srcimg: ''
    }
  },
  mounted() {

  },
  methods: {
    getimg(item) {
      this.srcimg = this.src + item.id;
      console.log(this.srcimg)
      document.getElementById('imgclick').click();

    },
    // 获取码稽查列表
    Tabledata(qrcode) {
      selectcorrect({
        qrcode: qrcode,
        page: 1,
        pageSize: 99
      }).then(response => {

        for (let i = 0; i < response.data.list.length; i++) {
          response.data.list[i].show = false

        } this.dataarr = response.data.list;
        console.log(this.dataarr);
        this.dialogVisible = true;
      });
    },
    handleClose(done) {
      this.dialogVisible = false;
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => { });
    }
  }
};
</script>
<style lang="scss" scoped></style>
